import api from "./api";
const svc = {
  listar:        (p={}) => { const qs=new URLSearchParams(Object.entries(p).filter(([,v])=>v!==""&&v!==undefined)); return api("GET",`/despesas-recorrentes?${qs}`); },
  buscarPorId:   id     => api("GET",`/despesas-recorrentes/${id}`),
  criar:         data   => api("POST","/despesas-recorrentes",data),
  atualizar:     (id,data) => api("PUT",`/despesas-recorrentes/${id}`,data),
  parcelasDoMes: (idCondominio,mes) => api("GET",`/despesas-recorrentes/parcelas-do-mes?idCondominio=${idCondominio}&mes=${mes}`),
  incluirNoBoleto:(id,refBoletoPeriodo) => api("PATCH",`/despesas-recorrentes/parcelas/${id}/incluir-boleto`,{refBoletoPeriodo}),
  atualizarParcela: (id, data) => api("PATCH", `/despesas-recorrentes/parcelas/${id}`, data),
};
export default svc;
